export default {
	start: {
		title: "AIプラットフォーム",
		tips: "スクロールで稼ごう！スマホ一つで毎日キャッシュアウト - あなたの電話がマネーマシンに！"
	},
	login: {
		tips: "アカウントをお持ちでない方",
		Signup: "新規登録",
		logIn: "ログイン",
		Remember: "ログイン情報を記憶する",
		form: {
			label: ["ユーザー名/電話番号", "パスワード"]
		},
		forgotPassword: "パスワードを忘れた？",
		contactSupport: "サポートに連絡",
		title: "アカウントを作成",
		content: ["アカウントが必要ですか？", "ここで作成"]
	},
	register: {
		form: {
			label: [
				"ユーザー名",
				"電話番号",
				"取引パスワード",
				"ログインパスワード",
				"ログインパスワードの確認",
				"性別",
				"招待コード",
				"メールアドレス",
				"認証コード"
			],
			rule: {
				Username: "ユーザー名は4～10文字で入力してください",
				Email: "有効なメールアドレスを入力してください",
				Phone: "電話番号は4桁以上で入力してください",
				ConfirmLoginPassword: "パスワードが一致しません",
				TradingPassword: "取引パスワードは6桁以上で入力してください",
				LoginPassword: "ログインパスワードは6桁以上で入力してください"
			}
		},
		sendMsg: "コードを送信しました！メッセージをご確認ください。",
		agree: ["{0}に同意します", "プライバシーポリシー、MSA", "および", "利用規約"],
		content: [
			"無料アカウントを作成",
			"すでにアカウントをお持ちですか？",
			"こちらからログイン",
			"アカウントを作成",
			"続行することで、以下に同意したことになります："
		]
	}
};
